module.exports = __webpack_public_path__ + "img/diplom-top-500-study.25454c4f.png";